<template>
  <div id="app">
    <div style="display: none; width: 0; height: 0;">Window-width: {{windowWidth}}, Window-height: {{windowHeight}}, Scrolled: {{scrolled}}</div>
    <hammocks/>
    <navbar @navigate="navigate"/> <!-- This uses position: sticky, which doesnt work on IE.  -->
    <component :is="navigation"></component>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      navigation: 'front-page',
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      scrolled: window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 900
    }
  },
  methods: {
    navigate (target) {
      window.scrollTo(0, this.windowHeight)
      this.navigation = target
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowHeight = window.innerHeight
        this.windowWidth = window.innerWidth
      })
      window.addEventListener('scroll', () => {
        this.scrolled = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
      })
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Shadows+Into+Light&display=swap');

  * {
    margin: 0;
    padding: 0;
  }
  
  body {
    background-color: rgb(0, 0, 0);
    padding: 0;
  }
  a, a:visited { 
    color: inherit;
    text-decoration-color: inherit;
  }
  
  h1 {
    font-family: courier;
    color: rgb(235, 235, 235);
    text-decoration-color: rgb(235, 235, 235);
    text-align: center;
    font-size: calc(32px);
  }
  h2{
    font-family: courier;
    color: rgb(231, 231, 231);
    text-decoration-color: rgb(231, 231, 231);
    text-align: center;
    font-size: calc(28px);
  }
  h3{
    font-family: courier;
    color: rgb(231, 231, 231);
    text-decoration-color: rgb(231, 231, 231);
    text-align: center;
    font-size: calc(24px);
  }
  p {
    text-align: center;
    color: rgb(238, 238, 238);
    text-decoration-color: rgb(238, 238, 238);
    font-family: courier;
    font-size: calc(22px);
    word-wrap: break-word;
  }
  .small-p{
    text-align: center;
    color: rgb(238, 238, 238);
    text-decoration-color: rgb(238, 238, 238);
    font-family: courier;
    font-size: calc(0.7em + 0.5vw);
    word-wrap: break-word;
  }

  .inline-block {
    display: inline-block;
    vertical-align: top;
  }

  .float-left {
    float: left;
  }

</style>
